<template>
  <div id="company-title" class="title bg-success">
    <div>{{ company.name }}</div>
    <button id="edit-button" class="btn btn-outline-light" @click="switchViewMode()">{{
      !isEditing.value ? "Editar" : "Visualizar" }}</button>
  </div>
  <fieldset :disabled="!isEditing.value || !isAdmin(user)">
    <div class="col-auto">
      <label for="nome" class="col-form-label">Nome</label>
    </div>
    <div class="col-auto">
      <input type="text" v-model="company.name" id="nome" class="form-control">
    </div>
    <div class="col-auto">
      <label for="pop" class="col-form-label">Email</label>
    </div>
    <div class="col-auto">
      <input type="text" v-model="company.email" id="pop" class="form-control">
    </div>
    <div class="col-auto">
      <label for="telefone" class="col-form-label">Telefone</label>
    </div>
    <div class="col-auto">
      <input v-model="company.phone" type="text" id="telefone" class="form-control">
    </div>

    <div v-if="isMetroUser(user)">
      <div class="d-flex gap-1">
        <input type="checkbox" v-model="company.showMonitoring"></input>
        <label for="phone" class="col-form-label">Monitoramento</label>
      </div>
      <select v-if="company.showMonitoring" v-model="company.scheduleMonitoring.id" class="form-select" aria-label="Select version">
        <option disabled value="">Selecione uma schedule</option>
        <option v-for="schedule in schedulesOptions" :key="schedule.name" :value="schedule.id">{{ schedule.name }}
        </option>
      </select>
      <div class="d-flex gap-1">
        <input type="checkbox" v-model="company.showService"></input>
        <label for="phone" class="col-form-label">Atendimento</label>  
      </div>
      <select v-if="company.showService" v-model="company.scheduleService.id" class="form-select" aria-label="Select version">
        <option disabled value="">Selecione uma schedule</option>
        <option v-for="schedule in schedulesOptions" :key="schedule.name" :value="schedule.id">{{ schedule.name }}
        </option>
      </select>
    </div>
    <button v-if="isEditing.value && isAdmin(user)" @click="saveChanges" type="button" class="actions btn btn-success btn-sm">
      Salvar
    </button>
  </fieldset>
  <fieldset v-if="isAdmin(user)" :disabled="!isEditing.value" >
    <div class="title subtitle">Filas</div>
    <div v-for="(queue, index) in company.queues" :key="queue" class="queue-form mb-3">
      <div class="row justify-content-between">
        <div class="col-md-2">
          <label for="queue-id-{{ index }}" class="form-label">Queue ID</label>
          <input type="text" id="queue-id-{{ index }}" class="form-control form-control-sm" v-model="queue.client" />
        </div>

        <div class="col-md-3">
          <label for="queue-url-{{ index }}" class="form-label">Queue URL</label>
          <input type="text" id="queue-url-{{ index }}" class="form-control form-control-sm" v-model="queue.url" />
        </div>

        <div class="col-md-2  d-flex flex-column align-items-center">
          <label for="team1-{{ index }}" class="form-label">Atendimento</label>
          <input v-if="company.showService" type="checkbox" id="team1-{{ index }}" class="form-check-input" value="atendimento"
            v-model="queue.showService" />
        </div>

        <div class="col-md-2  d-flex flex-column align-items-center">
          <label for="team2-{{ index }}" class="form-label">Monitoramento</label>
          <input v-if="company.showMonitoring" type="checkbox" id="team2-{{ index }}" class="form-check-input" value="monitoramento"
            v-model="queue.showMonitoring" />
        </div>

        <div class="col-md-2 d-flex align-items-center justify-content-center">
          <button v-if="isEditing.value" @click="() => queue.isDeleting = true" type="button"
            class="btn btn-danger btn-sm">
            Excluir
          </button>
          <ModalContent :is-modal-open="queue.isDeleting" @close="() => queue.isDeleting = false" @send="() => {
            deleteQueue(index);
            queue.isDeleting = false
          }" :title="`Excluir Fila ?`">Você tem certeza que deseja excluir essa configuração de fila ?
          </ModalContent>
        </div>
      </div>
    </div>

    <div class="d-flex gap-2">
      <button v-if="isEditing.value" @click="addQueue" type="button" class="actions btn btn-primary btn-sm">
        Adicionar
      </button>
      <button v-if="isEditing.value" @click="updateQueues" type="button" class="actions btn btn-success btn-sm">
        Salvar
      </button>
    </div>
  </fieldset>
  <fieldset v-if=isAdmin(user) :disabled="!isEditing.value">
    <div class="title subtitle">Tickets CSE e aguardando noc</div>
    <table class="table table-sm">
      <thead class="table-light">
        <tr>
          <th scope="col">Cse</th>
          <th scope="col">Esperando</th>
          <th scope="col">Inicial</th>
          <th scope="col">Fallowup</th>
          <th scope="col">Atendimento</th>
          <th scope="col">Monitoramento</th>
          <th scope="col">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(ticket, index) in company.tickets" :key="ticket">
          <td >
            <input
              type="checkbox"
              class="form-check-input"
              v-model="ticket.showCse"
              :disabled="!ticket.isEditing"
            />
          </td>
          <td >
            <input
              type="checkbox"
              class="form-check-input"
              v-model="ticket.showWaitingNoc"
              :disabled="!ticket.isEditing"
            />
          </td>
          <td >
            <input
              type="checkbox"
              class="form-check-input"
              v-model="ticket.showUncomented"
              :disabled="!ticket.isEditing"
            />
          </td>
          <td >
            <input
              type="checkbox"
              class="form-check-input"
              v-model="ticket.showFallowupExpired"
              :disabled="!ticket.isEditing"
            />
          </td>
          <td >
            <input
              type="checkbox"
              class="form-check-input"
              v-model="ticket.showService"
              :disabled="!ticket.isEditing"
            />
          </td>
          <td >
            <input
              v-if="company.showMonitoring"
              type="checkbox"
              class="form-check-input"
              v-model="ticket.showMonitoring"
              :disabled="!ticket.isEditing"
            />
          </td>
          <td >
            <div class="d-flex gap-1">
              <button
                v-if="!ticket.isEditing && isEditing.value"
                @click="() => startEditTicket(ticket)"
                type="button"
                class="btn btn-primary btn-sm"
              >
                Editar
              </button>
              <button
                v-if="ticket.isEditing"
                @click="() => saveTicket(ticket)"
                type="button"
                class="btn btn-success btn-sm"
              >
                Salvar
              </button>
              <button
                v-if="ticket.isEditing"
                @click="() => cancelEditTicket(ticket, index)"
                type="button"
                class="btn btn-secondary btn-sm"
              >
                Cancelar
              </button>
              <button
                v-if="isEditing.value && !ticket.isEditing"
                @click="() => ticket.isDeleting = true"
                type="button"
                class="btn btn-danger btn-sm"
              >
                Excluir
              </button>
            </div>
            <ModalContent
              :is-modal-open="ticket.isDeleting"
              @close="() => ticket.isDeleting = false"
              @send="() => {
                deleteTicket(index);
                ticket.isDeleting = false
              }"
              :title="`Excluir ticket ?`"
            >
              Você tem certeza que deseja excluir essa configuração de ticket ?
            </ModalContent>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex gap-2">
      <button v-if="isEditing.value" @click="addTicket" type="button" class="actions btn btn-primary btn-sm">
        Adicionar
      </button>
    </div>
  </fieldset>
  <fieldset v-if="isAdmin(user)">
    <div class="title subtitle">Zabbix</div>
    <table class="table table-sm">
      <thead class="table-light">
        <tr>
          <th scope="col" class="col-id">ID</th>
          <th scope="col" class="col-pop">URL</th>
          <th scope="col" class="col-pop">VERSION</th>
          <th scope="col" class="col-actions">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="zabbix in company.zabbixs" :key="zabbix.id">
          <td >{{ zabbix.id }}</td>
          <td >{{ zabbix.url }}</td>
          <td >{{ zabbix.version }}</td>
          <td  >
            <div class="d-flex gap-1">
              <router-link v-if="!isEditing.value" :to="`/empresas/zabbix/${zabbix.id}?mode=view`">
                <button type=" button" class="actions btn btn-info btn-sm">
                  Visualizar
                </button>
              </router-link>
              <router-link v-if="isEditing.value" :to="`/empresas/zabbix/${zabbix.id}?mode=edit`">
                <button type=" button" class="actions btn btn-primary btn-sm">
                  Editar
                </button>
              </router-link>
              <button v-if="isEditing.value" @click="() => zabbix.isDeleting = true" type="button"
                class="actions btn btn-danger btn-sm">
                Excluir
              </button>
              <ModalContent :is-modal-open="zabbix.isDeleting" @close="() => zabbix.isDeleting = false" @send="() => {
                deleteZabbix(zabbix.id);
                zabbix.isDeleting = false
              }" :title="`Excluir zabbix ?`">Você tem certeza que deseja excluir essa configuração de zabbix ?
              </ModalContent>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <button v-if="isEditing.value" @click="addZabbix" type="button" class="actions btn btn-primary btn-sm">
      Adicionar
    </button>
  </fieldset>
  <fieldset>
    <div class="title subtitle">Pops</div>
    <PaginateTable :items="company.pops" :reversed="true" v-slot="{ paginatedItems }">
      <table class="table table-sm">
        <thead class="table-light">
          <tr>
            <th scope="col" class="col-id">ID</th>
            <th scope="col" class="col-pop">Site (POP)</th>
            <th scope="col" class="col-pop">Telefone</th>
            <th scope="col" class="col-pop">Email</th>
            <th scope="col" class="col-actions">Ações</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="pop in paginatedItems" :key="pop.id">
            <td style="vertical-align: middle;">{{ pop.id }}</td>
            <td style="vertical-align: middle;">{{ pop.name }}</td>
            <td style="vertical-align: middle;">{{ pop.phone }}</td>
            <td style="vertical-align: middle;">{{ pop.email }}</td>
            <td class="text-center" style="vertical-align: middle;">
              <div class="d-flex gap-1">
                <router-link v-if="isEditing.value" :to="`/empresas/site/${pop.id}?mode=edit`">
                  <button type=" button" class="actions btn btn-primary btn-sm">
                    Editar
                  </button>
                </router-link>
                <router-link v-if="!isEditing.value" :to="`/empresas/site/${pop.id}?mode=view`">
                  <button type=" button" class="actions btn btn-info btn-sm">
                    Visualizar
                  </button>
                </router-link>
                <button v-if="isEditing.value" @click="() => pop.isDeleting = true" type="button"
                  class="actions btn btn-danger btn-sm">
                  Excluir
                </button>
                <ModalContent :is-modal-open="pop.isDeleting" @close="() => pop.isDeleting = false" @send="() => {
                  deletepop(pop.id);
                  pop.isDeleting = false
                }" :title="`Excluir pop ?`">Você tem certeza que deseja excluir essa configuração de pop ?
                </ModalContent>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </PaginateTable>
    <button v-if="isEditing.value" @click="addpop" type="button" class="actions btn btn-primary btn-sm">
      Adicionar
    </button>
  </fieldset>
  <fieldset>
    <div class="title subtitle">Trechos</div>
    <PaginateTable :items="company.sections" :reversed="true" v-slot="{ paginatedItems }">
      <table class="table table-sm">
        <thead class="table-light">
          <tr>
            <th scope="col" class="col-id">ID</th>
            <th scope="col" class="col-section-name">Nome</th>
            <th scope="col" class="col-section">Ponto A</th>
            <th scope="col" class="col-section">Ponto B</th>
            <th scope="col" class="col-actions">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="section in paginatedItems" :key="section.id">
            <td style="vertical-align: middle;">{{ section.id }}</td>
            <td style="vertical-align: middle;">{{ section.name }}</td>
            <td class="col-section" style="vertical-align: middle;">
              <div v-if="section.pointA">
                PopId: {{ section.pointA.popId }} <br>
                HostId: {{ section.pointA.hostId }} <br>
                ItemId: {{ section.pointA.itemId }} <br>
                TriggerId: {{ section.pointA.triggerId }}
              </div>
              <div v-else>
                PointA está vazio
              </div>
            </td>

            <td class="col-section" style="vertical-align: middle;">
              <div v-if="section.pointB">
                PopId: {{ section.pointB.popId }} <br>
                HostId: {{ section.pointB.hostId }} <br>
                ItemId: {{ section.pointB.itemId }} <br>
                TriggerId: {{ section.pointB.triggerId }}
              </div>
              <div v-else>
                PointB está vazio
              </div>
            </td>
            <td class="text-center" style="vertical-align: middle;">
              <div class="d-flex gap-1">
                <router-link v-if="isEditing.value" :to="`/empresas/trecho/${section.id}?mode=edit`">
                  <button type=" button" class="actions btn btn-primary btn-sm">
                    Editar
                  </button>
                </router-link>
                <router-link v-if="!isEditing.value" :to="`/empresas/trecho/${section.id}?mode=view`">
                  <button type=" button" class="actions btn btn-info btn-sm">
                    Visualizar
                  </button>
                </router-link>
                <button v-if="isEditing.value" @click="section.isDeleting = true" type="button"
                  class="actions btn btn-danger btn-sm">
                  Excluir
                </button>
                <ModalContent :is-modal-open="section.isDeleting" @close="() => section.isDeleting = false" @send="() => {
                  deleteSection(section.id);
                  section.isDeleting = false
                }" :title="`Excluir trecho ?`">Você tem certeza que deseja excluir essa configuração de trecho ?
                </ModalContent>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </PaginateTable>
    <button v-if="isEditing.value" @click="addSection" type="button" class="actions btn btn-primary btn-sm">
      Adicionar
    </button>
  </fieldset>
  <fieldset>
    <div class="title subtitle">Parceiros</div>

    <PaginateTable :items="company.partners" :reversed="true" v-slot="{ paginatedItems }">
      <table class="table table-sm">
        <thead class="table-light">
          <tr>
            <th scope="col" class="col-id">ID</th>
            <th scope="col" class="col-name">Nome</th>
            <th scope="col" class="col-phone">Telefone</th>
            <th scope="col" class="col-phone">Telefone de contato</th>
            <th scope="col" class="col-idErp">ID ERP</th>
            <th scope="col" class="col-actions">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="partner in paginatedItems" :key="partner.id">
            <td style="vertical-align: middle;">{{ partner.id }}</td>
            <td style="vertical-align: middle;">{{ partner.name }}</td>
            <td style="vertical-align: middle;">{{ partner.phone }}</td>
            <td style="vertical-align: middle;">{{ partner.contactNumber }}</td>
            <td style="vertical-align: middle;">{{ partner.idErp }}</td>
            <td class="text-center" style="vertical-align: middle;">
              <div class="d-flex gap-1">
                <router-link v-if="isEditing.value" :to="`/empresas/parceiro/${partner.id}?mode=edit`">
                  <a type="button" class="actions btn btn-secondary btn-sm">Editar</a>
                </router-link>
                <router-link v-if="!isEditing.value" :to="`/empresas/parceiro/${partner.id}?mode=view`">
                  <a type="button" class="actions btn btn-info btn-sm">Visualizar</a>
                </router-link>
                <a v-if="isEditing.value" @click="() => partner.isDeleting = true" type="button"
                  class="actions btn btn-danger btn-sm">Excluir</a>
                <ModalContent :is-modal-open="partner.isDeleting" @close="() => partner.isDeleting = false" @send="() => {
                  deletePartner(partner.id);
                  partner.isDeleting = false
                }" :title="`Excluir parceiro ?`">Você tem certeza que deseja excluir essa configuração de parceiro ?
                </ModalContent>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </PaginateTable>

    <button v-if="isEditing.value" @click="addPartner" type="button" class="mx-auto actions btn btn-primary btn-sm">
      Adicionar
    </button>
  </fieldset>
  <fieldset>
    <div class="title subtitle">Instruções</div>

    <PaginateTable :items="company.instructions" :reversed="true" v-slot="{ paginatedItems }">
      <table class="table table-sm">
        <thead class="table-light">
          <tr>
            <th scope="col" class="col-id">ID</th>
            <th scope="col" class="col-name">Nome</th>
            <th scope="col" class="col-link">Link</th>
            <th scope="col" class="col-actions">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="instruction in paginatedItems" :key="instruction.id">
            <td style="vertical-align: middle;">{{ instruction.id }}</td>
            <td style="vertical-align: middle;">{{ instruction.name }}</td>
            <td style="vertical-align: middle;">
              <a :href="instruction.link" target="_blank">{{ instruction.link }}</a>
            </td>
            <td class="text-center" style="vertical-align: middle;">
              <div class="d-flex gap-1">
                <router-link v-if="isEditing.value" :to="`instrucao/${instruction.id}?mode=edit`">
                  <a type="button" class="actions btn btn-secondary btn-sm">Editar</a>
                </router-link>
                <router-link v-if="!isEditing.value" :to="`instrucao/${instruction.id}?mode=view`">
                  <a type="button" class="actions btn btn-info btn-sm">Visualizar</a>
                </router-link>
                <a v-if="isEditing.value" @click="instruction.isDeleting = true" type="button"
                  class="actions btn btn-danger btn-sm">Excluir</a>
                <ModalContent :is-modal-open="instruction.isDeleting" @close="() => instruction.isDeleting = false"
                  @send="() => {
                    deleteInstruction(instruction.id);
                    instruction.isDeleting = false
                  }" :title="`Excluir instrução ?`">Você tem certeza que deseja excluir essa configuração de instrução
                  ?
                </ModalContent>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </PaginateTable>

    <button v-if="isEditing.value" @click="addInstruction" type="button" class="mx-auto actions btn btn-primary btn-sm">
      Adicionar
    </button>
  </fieldset>

  <fieldset>
    <div class="title subtitle">Sistema de whatsapp</div>
    <PaginateTable :items="company.whatsappSystems" :reversed="true" v-slot="{ paginatedItems }">
      <table class="table table-sm">
        <thead class="table-light">
          <tr>
            <th scope="col" class="col-id">ID</th>
            <th scope="col" class="col-name">Sistema</th>
            <th scope="col" class="col-actions">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="whatsappSystem in paginatedItems" :key="whatsappSystem.id">
            <td style="vertical-align: middle;">{{ whatsappSystem.id }}</td>
            <td style="vertical-align: middle;">{{ whatsappSystem.system }}</td>
            <td class="text-center" style="vertical-align: middle;">
              <div class="d-flex gap-1">
                <router-link v-if="isEditing.value" :to="`/empresas/sistema-de-whatsapp/${whatsappSystem.id}?mode=edit`">
                  <a type="button" class="actions btn btn-secondary btn-sm">Editar</a>
                </router-link>
                <router-link v-if="!isEditing.value" :to="`/empresas/sistema-de-whatsapp/${whatsappSystem.id}?mode=view`">
                  <a type="button" class="actions btn btn-info btn-sm">Visualizar</a>
                </router-link>
                <a v-if="isEditing.value" @click="() => whatsappSystem.isDeleting = true" type="button"
                  class="actions btn btn-danger btn-sm">Excluir</a>
                <ModalContent :is-modal-open="whatsappSystem.isDeleting"
                  @close="() => whatsappSystem.isDeleting = false" @send="() => {
                    deleteWhatsappSystem(whatsappSystem.id);
                    whatsappSystem.isDeleting = false
                  }" :title="`Excluir parceiro ?`">Você tem certeza que deseja excluir essa configuração de parceiro ?
                </ModalContent>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </PaginateTable>

    <button type="button" class="actions btn btn-primary btn-sm" @click="addWhatsappSystem">Adicionar</button>
  </fieldset>
</template>

<script>
import { CompanyService, instructionService, PartnerService, PopService, QueueService, schedulePolicyService, sectionService, TicketService, whatsappSystemService, zabbixService } from '@/services/backend/ApiService';
import PaginateTable from '@/components/PaginateTable.vue'
import useEditMode from '@/services/EditingService';
import ModalContent from '@/components/ModalContent.vue';
import { isAdmin, isMetroUser } from '../../../../zabbix-shared/utils/user';
import OnlineUserService from '@/services/OnlineUserService';

export default {
  components: {
    ModalContent,
    PaginateTable
  },
  data() {
    return {
      user: OnlineUserService.waitForUser(),
      company: {
        id: this.$route.params.id,
        name: '',
        phone: '',
        link: '',
        pops: [],
        zabbixs: [],
        sections: [],
        queues: [],
        tickets: [],
        whatsappSystem: [],
        scheduleMonitoring: {id: null},
        scheduleService: {id: null}
      },
      schedulesOptions: []
    };
  },
  setup() {
    const isEditing = useEditMode();

    return { isEditing };
  },
  async mounted() {
    this.schedulesOptions = await schedulePolicyService.findAll();
    this.user = await OnlineUserService.waitForUser();
    this.loadCompany();
  },
  computed: {
    point() {
      return JSON.parse();
    }
  },
  methods: {
    isAdmin,
    isMetroUser,
    parsedPoint(point) {
      return point ? JSON.parse(point) : null;
    },
    async loadCompany() {
      try {
        this.company = await CompanyService.findOne(this.company.id)
        if(!this.company?.scheduleMonitoring){
          this.company.scheduleMonitoring = {id: null}
        }

         if(!this.company?.scheduleService){
          this.company.scheduleService = {id: null}
        }

        if (this.company.tickets) {
          this.company.tickets.forEach(ticket => {
            if (ticket.isEditing === undefined) {
              ticket.isEditing = false;
            }
          });
        }
      }
      catch (error) {
        console.error("Erro ao carregar a empresa:", error);
      }
    },

    async saveChanges() {
      try {
        this.company = await CompanyService.update(this.company.id, this.company)
      } catch (error) {
        console.error("Erro ao salvar as alterações:", error);
      }
    },
    async addpop() {
      let newPop = {
        company: {
          id: this.company.id
        }
      }

      newPop = await PopService.create(newPop);
      this.company.pops.push(newPop)
    },
    async addSection() {
      let newSection = {
        company: {
          id:this.company.id
        }
      }

      newSection = await sectionService.create(newSection);
      this.company.sections.push(newSection);
    },
    async deleteSection(sectionId) {
      await sectionService.delete(sectionId);
      this.company.sections = this.company.sections.filter(section => section.id !== sectionId);
    },
    async addZabbix() {
      let newZabbix = {
        company: {
          id: this.company.id
        }
      };

      newZabbix = await zabbixService.create(newZabbix);

      this.company.zabbixs.push(newZabbix);
    },
    async deletepop(id) {
      await PopService.delete(id)
      this.company.pops = this.company.pops.filter(pop => pop.id !== id);
    },
    async deleteZabbix(id) {
      await zabbixService.delete(id)
      this.company.zabbixs = this.company.zabbixs.filter(zabbix => zabbix.id !== id);
    },
    async addQueue() {
      const newQueue = {
        company: {
          id: this.company.id
        }
      };

      newQueue.id = (await QueueService.create(newQueue)).id;
      
      if (!this.company.queues) this.company.queues = [];
      this.company.queues.push(newQueue);
    },
    async deleteQueue(index) {
      await QueueService.delete(this.company.queues[index].id);
      this.company.queues.splice(index, 1);
    },
    async updateQueues() {
      for (let queue of this.company.queues) {
        await QueueService.update(queue.id,queue);
      }
    },
    async addTicket() {
      let newticket = {
        company: {
          id: this.company.id
        }
      };

      newticket = await TicketService.create(newticket);
      newticket.isEditing = false;

      if (!this.company.tickets) this.company.tickets = []
      this.company.tickets.push(newticket);
    },
    async deleteTicket(index) {
      await TicketService.delete(this.company.tickets[index].id)
      this.company.tickets.splice(index, 1);
    },
    async updateTickets() {
      for (let ticket of this.company.tickets) {
        await TicketService.update(ticket.id, ticket)
      }
    },
    startEditTicket(ticket) {
      ticket.originalValues = {
        showCse: ticket.showCse,
        showWaitingNoc: ticket.showWaitingNoc,
        showUncomented: ticket.showUncomented,
        showFallowupExpired: ticket.showFallowupExpired,
        showService: ticket.showService,
        showMonitoring: ticket.showMonitoring
      };
      ticket.isEditing = true;
    },
    async saveTicket(ticket) {
      try {
        await TicketService.update(ticket.id, ticket);
        ticket.isEditing = false;

        if (ticket.originalValues) {
          delete ticket.originalValues;
        }
      } catch (error) {
        console.error("Erro ao salvar ticket:", error);
      }
    },
    cancelEditTicket(ticket, index) {
      if (ticket.originalValues) {
        Object.assign(ticket, ticket.originalValues);
        delete ticket.originalValues;
      }
      ticket.isEditing = false;
    },
    async addPartner() {
      let newPartner = {
        company: {
          id: this.company.id
        }
      };

      try {
        const createdPartner = await PartnerService.create(newPartner);
        this.company.partners.push(createdPartner);
      } catch (error) {
        console.error("Erro ao adicionar parceiro:", error);
      }
    },
    async deletePartner(id) {
      try {
        await PartnerService.delete(id);
        this.company.partners = this.company.partners.filter((partner) => partner.id !== id);
      } catch (error) {
        console.error("Erro ao excluir o parceiro:", error);
      }
    },
    async addInstruction() {
      let newInstruction = {
        company: {
          id: this.company.id
        }
      };

      try {
        const createdInstruction = await instructionService.create(newInstruction);
        this.company.instructions.push(createdInstruction);
      } catch (error) {
        console.error("Erro ao adicionar instrução:", error);
      }
    },
    async addWhatsappSystem() {
      let newWhatsappSystem = {
        company: {
          id: this.company.id
        }
      };

      const createdWhatsappSystem = await whatsappSystemService.create(newWhatsappSystem);
      this.company.whatsappSystems.push(createdWhatsappSystem);
    },
    async deleteInstruction(id) {
      try {
        await instructionService.delete(id);
        this.company.instructions = this.company.instructions.filter((instruction) => instruction.id !== id);
      } catch (error) {
        console.error("Erro ao excluir a instrução:", error);
      }
    },
    async deleteWhatsappSystem(id) {
      await whatsappSystemService.delete(id);
      this.company.whatsappSystems = this.company.whatsappSystems.filter((whatsappSystems) => whatsappSystems.id !== id);
    },
    switchViewMode() {
      this.isEditing.value ? this.enterViewMode() : this.enterEditMode()
    },
    enterEditMode() {
      this.$router.push({
        query: { ...this.$route.query, mode: 'edit' }
      });
    },
    enterViewMode() {
      this.$router.push({
        query: { ...this.$route.query, mode: 'view' }
      });
    }
  }
};
</script>

<style scoped>
.col-actions {
  width: 150px;
}

#company-title {
  position: relative;
}

#edit-button {
  position: absolute;
  right: 20px;
}
</style>
